<template>
  <div class="text-field">
    <div
      class="m-form-element js-m-form-element"
      :class="{'state-m-form-element--input-error': v$[slug] && v$[slug].$error}"
    >
      <div class="a-text-input js-a-text-input">
        <input
          :id="slug"
          class="a-text-input__input js-a-text-input__input"
          :class="{'state-a-text-input--has-value': model.length > 0}"
          :type="type"
          :disabled="!!disabled"
          :data-cy="slug"
          :name="slug"
          :value="model"
        >
        <label
          class="a-text-input__label js-a-text-input__label"
          :for="slug"
        >
          {{ label }}
        </label>
      </div>

      <!-- Message d'erreur -->
      <ErrorMessage :validation-status="v$[slug]" />
    </div>
  </div>
</template>

<script>

import ErrorMessage from "./ErrorMessage";

export default {
  name: "InputText",
  components: {
    ErrorMessage
  },
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    v$: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    }
  }
}
</script>

<style scoped>



</style>
